/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VersionRouteImport } from './routes/version'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PoliciesIndexRouteImport } from './routes/policies/index'
import { Route as NhiOlcmIndexRouteImport } from './routes/nhi-olcm/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as IdentitiesIndexRouteImport } from './routes/identities/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as AgentsIndexRouteImport } from './routes/agents.index'
import { Route as AgentRuntimeAuthzIndexRouteImport } from './routes/agent-runtime-authz.index'
import { Route as AgentGatewayIndexRouteImport } from './routes/agent-gateway.index'
import { Route as PoliciesSplatRouteImport } from './routes/policies/$'
import { Route as NhiOlcmSplatRouteImport } from './routes/nhi-olcm/$'
import { Route as IntegrationsSplatRouteImport } from './routes/integrations/$'
import { Route as IdentitiesSplatRouteImport } from './routes/identities/$'
import { Route as DashboardSplatRouteImport } from './routes/dashboard.$'
import { Route as AgentsSplatRouteImport } from './routes/agents.$'
import { Route as AgentRuntimeAuthzSplatRouteImport } from './routes/agent-runtime-authz.$'
import { Route as AgentGatewaySplatRouteImport } from './routes/agent-gateway.$'
import { Route as IntegrationsUniversalOnboardingIndexRouteImport } from './routes/integrations/universalOnboarding.index'
import { Route as AdminOverviewIndexRouteImport } from './routes/admin/overview/index'
import { Route as AdminMfaIndexRouteImport } from './routes/admin/mfa/index'
import { Route as AdminIspmUsersIndexRouteImport } from './routes/admin/ispm-users/index'
import { Route as AdminAuditTrailIndexRouteImport } from './routes/admin/audit-trail/index'
import { Route as IntegrationsUniversalOnboardingSplatRouteImport } from './routes/integrations/universalOnboarding.$'
import { Route as AdminAuditTrailSplatRouteImport } from './routes/admin/audit-trail/$'
import { Route as AdminSettingsSsoSettingsIndexRouteImport } from './routes/admin/settings/sso-settings/index'
import { Route as AdminSettingsSsoSettingsEditRouteImport } from './routes/admin/settings/sso-settings/edit'
import { Route as AdminSettingsSsoSettingsCreateRouteImport } from './routes/admin/settings/sso-settings/create'

const VersionRoute = VersionRouteImport.update({
  id: '/version',
  path: '/version',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesIndexRoute = PoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => rootRouteImport,
} as any)
const NhiOlcmIndexRoute = NhiOlcmIndexRouteImport.update({
  id: '/nhi-olcm/',
  path: '/nhi-olcm/',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/integrations/',
  path: '/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentitiesIndexRoute = IdentitiesIndexRouteImport.update({
  id: '/identities/',
  path: '/identities/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRuntimeAuthzIndexRoute = AgentRuntimeAuthzIndexRouteImport.update({
  id: '/agent-runtime-authz/',
  path: '/agent-runtime-authz/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentGatewayIndexRoute = AgentGatewayIndexRouteImport.update({
  id: '/agent-gateway/',
  path: '/agent-gateway/',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesSplatRoute = PoliciesSplatRouteImport.update({
  id: '/policies/$',
  path: '/policies/$',
  getParentRoute: () => rootRouteImport,
} as any)
const NhiOlcmSplatRoute = NhiOlcmSplatRouteImport.update({
  id: '/nhi-olcm/$',
  path: '/nhi-olcm/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsSplatRoute = IntegrationsSplatRouteImport.update({
  id: '/integrations/$',
  path: '/integrations/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IdentitiesSplatRoute = IdentitiesSplatRouteImport.update({
  id: '/identities/$',
  path: '/identities/$',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSplatRoute = DashboardSplatRouteImport.update({
  id: '/dashboard/$',
  path: '/dashboard/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsSplatRoute = AgentsSplatRouteImport.update({
  id: '/agents/$',
  path: '/agents/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRuntimeAuthzSplatRoute = AgentRuntimeAuthzSplatRouteImport.update({
  id: '/agent-runtime-authz/$',
  path: '/agent-runtime-authz/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentGatewaySplatRoute = AgentGatewaySplatRouteImport.update({
  id: '/agent-gateway/$',
  path: '/agent-gateway/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsUniversalOnboardingIndexRoute =
  IntegrationsUniversalOnboardingIndexRouteImport.update({
    id: '/integrations/universalOnboarding/',
    path: '/integrations/universalOnboarding/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminOverviewIndexRoute = AdminOverviewIndexRouteImport.update({
  id: '/overview/',
  path: '/overview/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMfaIndexRoute = AdminMfaIndexRouteImport.update({
  id: '/mfa/',
  path: '/mfa/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminIspmUsersIndexRoute = AdminIspmUsersIndexRouteImport.update({
  id: '/ispm-users/',
  path: '/ispm-users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditTrailIndexRoute = AdminAuditTrailIndexRouteImport.update({
  id: '/audit-trail/',
  path: '/audit-trail/',
  getParentRoute: () => AdminRoute,
} as any)
const IntegrationsUniversalOnboardingSplatRoute =
  IntegrationsUniversalOnboardingSplatRouteImport.update({
    id: '/integrations/universalOnboarding/$',
    path: '/integrations/universalOnboarding/$',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAuditTrailSplatRoute = AdminAuditTrailSplatRouteImport.update({
  id: '/audit-trail/$',
  path: '/audit-trail/$',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsSsoSettingsIndexRoute =
  AdminSettingsSsoSettingsIndexRouteImport.update({
    id: '/settings/sso-settings/',
    path: '/settings/sso-settings/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsSsoSettingsEditRoute =
  AdminSettingsSsoSettingsEditRouteImport.update({
    id: '/settings/sso-settings/edit',
    path: '/settings/sso-settings/edit',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSettingsSsoSettingsCreateRoute =
  AdminSettingsSsoSettingsCreateRouteImport.update({
    id: '/settings/sso-settings/create',
    path: '/settings/sso-settings/create',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/version': typeof VersionRoute
  '/agent-gateway/$': typeof AgentGatewaySplatRoute
  '/agent-runtime-authz/$': typeof AgentRuntimeAuthzSplatRoute
  '/agents/$': typeof AgentsSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/$': typeof IntegrationsSplatRoute
  '/nhi-olcm/$': typeof NhiOlcmSplatRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent-gateway/': typeof AgentGatewayIndexRoute
  '/agent-runtime-authz/': typeof AgentRuntimeAuthzIndexRoute
  '/agents/': typeof AgentsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/identities/': typeof IdentitiesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/nhi-olcm/': typeof NhiOlcmIndexRoute
  '/policies/': typeof PoliciesIndexRoute
  '/admin/audit-trail/$': typeof AdminAuditTrailSplatRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/audit-trail/': typeof AdminAuditTrailIndexRoute
  '/admin/ispm-users/': typeof AdminIspmUsersIndexRoute
  '/admin/mfa/': typeof AdminMfaIndexRoute
  '/admin/overview/': typeof AdminOverviewIndexRoute
  '/integrations/universalOnboarding/': typeof IntegrationsUniversalOnboardingIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings/': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/version': typeof VersionRoute
  '/agent-gateway/$': typeof AgentGatewaySplatRoute
  '/agent-runtime-authz/$': typeof AgentRuntimeAuthzSplatRoute
  '/agents/$': typeof AgentsSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/$': typeof IntegrationsSplatRoute
  '/nhi-olcm/$': typeof NhiOlcmSplatRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent-gateway': typeof AgentGatewayIndexRoute
  '/agent-runtime-authz': typeof AgentRuntimeAuthzIndexRoute
  '/agents': typeof AgentsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/identities': typeof IdentitiesIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/nhi-olcm': typeof NhiOlcmIndexRoute
  '/policies': typeof PoliciesIndexRoute
  '/admin/audit-trail/$': typeof AdminAuditTrailSplatRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/audit-trail': typeof AdminAuditTrailIndexRoute
  '/admin/ispm-users': typeof AdminIspmUsersIndexRoute
  '/admin/mfa': typeof AdminMfaIndexRoute
  '/admin/overview': typeof AdminOverviewIndexRoute
  '/integrations/universalOnboarding': typeof IntegrationsUniversalOnboardingIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/version': typeof VersionRoute
  '/agent-gateway/$': typeof AgentGatewaySplatRoute
  '/agent-runtime-authz/$': typeof AgentRuntimeAuthzSplatRoute
  '/agents/$': typeof AgentsSplatRoute
  '/dashboard/$': typeof DashboardSplatRoute
  '/identities/$': typeof IdentitiesSplatRoute
  '/integrations/$': typeof IntegrationsSplatRoute
  '/nhi-olcm/$': typeof NhiOlcmSplatRoute
  '/policies/$': typeof PoliciesSplatRoute
  '/agent-gateway/': typeof AgentGatewayIndexRoute
  '/agent-runtime-authz/': typeof AgentRuntimeAuthzIndexRoute
  '/agents/': typeof AgentsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/identities/': typeof IdentitiesIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/nhi-olcm/': typeof NhiOlcmIndexRoute
  '/policies/': typeof PoliciesIndexRoute
  '/admin/audit-trail/$': typeof AdminAuditTrailSplatRoute
  '/integrations/universalOnboarding/$': typeof IntegrationsUniversalOnboardingSplatRoute
  '/admin/audit-trail/': typeof AdminAuditTrailIndexRoute
  '/admin/ispm-users/': typeof AdminIspmUsersIndexRoute
  '/admin/mfa/': typeof AdminMfaIndexRoute
  '/admin/overview/': typeof AdminOverviewIndexRoute
  '/integrations/universalOnboarding/': typeof IntegrationsUniversalOnboardingIndexRoute
  '/admin/settings/sso-settings/create': typeof AdminSettingsSsoSettingsCreateRoute
  '/admin/settings/sso-settings/edit': typeof AdminSettingsSsoSettingsEditRoute
  '/admin/settings/sso-settings/': typeof AdminSettingsSsoSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/version'
    | '/agent-gateway/$'
    | '/agent-runtime-authz/$'
    | '/agents/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/$'
    | '/nhi-olcm/$'
    | '/policies/$'
    | '/agent-gateway/'
    | '/agent-runtime-authz/'
    | '/agents/'
    | '/dashboard/'
    | '/identities/'
    | '/integrations/'
    | '/nhi-olcm/'
    | '/policies/'
    | '/admin/audit-trail/$'
    | '/integrations/universalOnboarding/$'
    | '/admin/audit-trail/'
    | '/admin/ispm-users/'
    | '/admin/mfa/'
    | '/admin/overview/'
    | '/integrations/universalOnboarding/'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/version'
    | '/agent-gateway/$'
    | '/agent-runtime-authz/$'
    | '/agents/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/$'
    | '/nhi-olcm/$'
    | '/policies/$'
    | '/agent-gateway'
    | '/agent-runtime-authz'
    | '/agents'
    | '/dashboard'
    | '/identities'
    | '/integrations'
    | '/nhi-olcm'
    | '/policies'
    | '/admin/audit-trail/$'
    | '/integrations/universalOnboarding/$'
    | '/admin/audit-trail'
    | '/admin/ispm-users'
    | '/admin/mfa'
    | '/admin/overview'
    | '/integrations/universalOnboarding'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/version'
    | '/agent-gateway/$'
    | '/agent-runtime-authz/$'
    | '/agents/$'
    | '/dashboard/$'
    | '/identities/$'
    | '/integrations/$'
    | '/nhi-olcm/$'
    | '/policies/$'
    | '/agent-gateway/'
    | '/agent-runtime-authz/'
    | '/agents/'
    | '/dashboard/'
    | '/identities/'
    | '/integrations/'
    | '/nhi-olcm/'
    | '/policies/'
    | '/admin/audit-trail/$'
    | '/integrations/universalOnboarding/$'
    | '/admin/audit-trail/'
    | '/admin/ispm-users/'
    | '/admin/mfa/'
    | '/admin/overview/'
    | '/integrations/universalOnboarding/'
    | '/admin/settings/sso-settings/create'
    | '/admin/settings/sso-settings/edit'
    | '/admin/settings/sso-settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
  VersionRoute: typeof VersionRoute
  AgentGatewaySplatRoute: typeof AgentGatewaySplatRoute
  AgentRuntimeAuthzSplatRoute: typeof AgentRuntimeAuthzSplatRoute
  AgentsSplatRoute: typeof AgentsSplatRoute
  DashboardSplatRoute: typeof DashboardSplatRoute
  IdentitiesSplatRoute: typeof IdentitiesSplatRoute
  IntegrationsSplatRoute: typeof IntegrationsSplatRoute
  NhiOlcmSplatRoute: typeof NhiOlcmSplatRoute
  PoliciesSplatRoute: typeof PoliciesSplatRoute
  AgentGatewayIndexRoute: typeof AgentGatewayIndexRoute
  AgentRuntimeAuthzIndexRoute: typeof AgentRuntimeAuthzIndexRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  IdentitiesIndexRoute: typeof IdentitiesIndexRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  NhiOlcmIndexRoute: typeof NhiOlcmIndexRoute
  PoliciesIndexRoute: typeof PoliciesIndexRoute
  IntegrationsUniversalOnboardingSplatRoute: typeof IntegrationsUniversalOnboardingSplatRoute
  IntegrationsUniversalOnboardingIndexRoute: typeof IntegrationsUniversalOnboardingIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/version': {
      id: '/version'
      path: '/version'
      fullPath: '/version'
      preLoaderRoute: typeof VersionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/': {
      id: '/policies/'
      path: '/policies'
      fullPath: '/policies/'
      preLoaderRoute: typeof PoliciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nhi-olcm/': {
      id: '/nhi-olcm/'
      path: '/nhi-olcm'
      fullPath: '/nhi-olcm/'
      preLoaderRoute: typeof NhiOlcmIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/integrations'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identities/': {
      id: '/identities/'
      path: '/identities'
      fullPath: '/identities/'
      preLoaderRoute: typeof IdentitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-runtime-authz/': {
      id: '/agent-runtime-authz/'
      path: '/agent-runtime-authz'
      fullPath: '/agent-runtime-authz/'
      preLoaderRoute: typeof AgentRuntimeAuthzIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-gateway/': {
      id: '/agent-gateway/'
      path: '/agent-gateway'
      fullPath: '/agent-gateway/'
      preLoaderRoute: typeof AgentGatewayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/$': {
      id: '/policies/$'
      path: '/policies/$'
      fullPath: '/policies/$'
      preLoaderRoute: typeof PoliciesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nhi-olcm/$': {
      id: '/nhi-olcm/$'
      path: '/nhi-olcm/$'
      fullPath: '/nhi-olcm/$'
      preLoaderRoute: typeof NhiOlcmSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/$': {
      id: '/integrations/$'
      path: '/integrations/$'
      fullPath: '/integrations/$'
      preLoaderRoute: typeof IntegrationsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identities/$': {
      id: '/identities/$'
      path: '/identities/$'
      fullPath: '/identities/$'
      preLoaderRoute: typeof IdentitiesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/$': {
      id: '/dashboard/$'
      path: '/dashboard/$'
      fullPath: '/dashboard/$'
      preLoaderRoute: typeof DashboardSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$': {
      id: '/agents/$'
      path: '/agents/$'
      fullPath: '/agents/$'
      preLoaderRoute: typeof AgentsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-runtime-authz/$': {
      id: '/agent-runtime-authz/$'
      path: '/agent-runtime-authz/$'
      fullPath: '/agent-runtime-authz/$'
      preLoaderRoute: typeof AgentRuntimeAuthzSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent-gateway/$': {
      id: '/agent-gateway/$'
      path: '/agent-gateway/$'
      fullPath: '/agent-gateway/$'
      preLoaderRoute: typeof AgentGatewaySplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/universalOnboarding/': {
      id: '/integrations/universalOnboarding/'
      path: '/integrations/universalOnboarding'
      fullPath: '/integrations/universalOnboarding/'
      preLoaderRoute: typeof IntegrationsUniversalOnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/overview/': {
      id: '/admin/overview/'
      path: '/overview'
      fullPath: '/admin/overview/'
      preLoaderRoute: typeof AdminOverviewIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/mfa/': {
      id: '/admin/mfa/'
      path: '/mfa'
      fullPath: '/admin/mfa/'
      preLoaderRoute: typeof AdminMfaIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ispm-users/': {
      id: '/admin/ispm-users/'
      path: '/ispm-users'
      fullPath: '/admin/ispm-users/'
      preLoaderRoute: typeof AdminIspmUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit-trail/': {
      id: '/admin/audit-trail/'
      path: '/audit-trail'
      fullPath: '/admin/audit-trail/'
      preLoaderRoute: typeof AdminAuditTrailIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/integrations/universalOnboarding/$': {
      id: '/integrations/universalOnboarding/$'
      path: '/integrations/universalOnboarding/$'
      fullPath: '/integrations/universalOnboarding/$'
      preLoaderRoute: typeof IntegrationsUniversalOnboardingSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit-trail/$': {
      id: '/admin/audit-trail/$'
      path: '/audit-trail/$'
      fullPath: '/admin/audit-trail/$'
      preLoaderRoute: typeof AdminAuditTrailSplatRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/sso-settings/': {
      id: '/admin/settings/sso-settings/'
      path: '/settings/sso-settings'
      fullPath: '/admin/settings/sso-settings/'
      preLoaderRoute: typeof AdminSettingsSsoSettingsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/sso-settings/edit': {
      id: '/admin/settings/sso-settings/edit'
      path: '/settings/sso-settings/edit'
      fullPath: '/admin/settings/sso-settings/edit'
      preLoaderRoute: typeof AdminSettingsSsoSettingsEditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings/sso-settings/create': {
      id: '/admin/settings/sso-settings/create'
      path: '/settings/sso-settings/create'
      fullPath: '/admin/settings/sso-settings/create'
      preLoaderRoute: typeof AdminSettingsSsoSettingsCreateRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAuditTrailSplatRoute: typeof AdminAuditTrailSplatRoute
  AdminAuditTrailIndexRoute: typeof AdminAuditTrailIndexRoute
  AdminIspmUsersIndexRoute: typeof AdminIspmUsersIndexRoute
  AdminMfaIndexRoute: typeof AdminMfaIndexRoute
  AdminOverviewIndexRoute: typeof AdminOverviewIndexRoute
  AdminSettingsSsoSettingsCreateRoute: typeof AdminSettingsSsoSettingsCreateRoute
  AdminSettingsSsoSettingsEditRoute: typeof AdminSettingsSsoSettingsEditRoute
  AdminSettingsSsoSettingsIndexRoute: typeof AdminSettingsSsoSettingsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditTrailSplatRoute: AdminAuditTrailSplatRoute,
  AdminAuditTrailIndexRoute: AdminAuditTrailIndexRoute,
  AdminIspmUsersIndexRoute: AdminIspmUsersIndexRoute,
  AdminMfaIndexRoute: AdminMfaIndexRoute,
  AdminOverviewIndexRoute: AdminOverviewIndexRoute,
  AdminSettingsSsoSettingsCreateRoute: AdminSettingsSsoSettingsCreateRoute,
  AdminSettingsSsoSettingsEditRoute: AdminSettingsSsoSettingsEditRoute,
  AdminSettingsSsoSettingsIndexRoute: AdminSettingsSsoSettingsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
  VersionRoute: VersionRoute,
  AgentGatewaySplatRoute: AgentGatewaySplatRoute,
  AgentRuntimeAuthzSplatRoute: AgentRuntimeAuthzSplatRoute,
  AgentsSplatRoute: AgentsSplatRoute,
  DashboardSplatRoute: DashboardSplatRoute,
  IdentitiesSplatRoute: IdentitiesSplatRoute,
  IntegrationsSplatRoute: IntegrationsSplatRoute,
  NhiOlcmSplatRoute: NhiOlcmSplatRoute,
  PoliciesSplatRoute: PoliciesSplatRoute,
  AgentGatewayIndexRoute: AgentGatewayIndexRoute,
  AgentRuntimeAuthzIndexRoute: AgentRuntimeAuthzIndexRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  IdentitiesIndexRoute: IdentitiesIndexRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  NhiOlcmIndexRoute: NhiOlcmIndexRoute,
  PoliciesIndexRoute: PoliciesIndexRoute,
  IntegrationsUniversalOnboardingSplatRoute:
    IntegrationsUniversalOnboardingSplatRoute,
  IntegrationsUniversalOnboardingIndexRoute:
    IntegrationsUniversalOnboardingIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
